// TMDB API Service
const API_KEY = 'bc1ef8f6dd8af37ca05b6df3011d71cb';
const BASE_URL = 'https://api.themoviedb.org/3';
const IMAGE_BASE_URL = 'https://image.tmdb.org/t/p';

export const tmdbService = {
  // Search for movies
  async searchMovies(query, page = 1) {
    try {
      const response = await fetch(
        `${BASE_URL}/search/movie?api_key=${API_KEY}&query=${encodeURIComponent(query)}&page=${page}&include_adult=false`
      );
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('TMDB Search Error:', error);
      throw error;
    }
  },

  // Get movie details
  async getMovieDetails(movieId) {
    try {
      const response = await fetch(
        `${BASE_URL}/movie/${movieId}?api_key=${API_KEY}&append_to_response=videos,credits`
      );
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('TMDB Details Error:', error);
      throw error;
    }
  },

  // Get popular movies
  async getPopularMovies(page = 1) {
    try {
      const response = await fetch(
        `${BASE_URL}/movie/popular?api_key=${API_KEY}&page=${page}`
      );
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('TMDB Popular Error:', error);
      throw error;
    }
  },

  // Get upcoming movies
  async getUpcomingMovies(page = 1) {
    try {
      const response = await fetch(
        `${BASE_URL}/movie/upcoming?api_key=${API_KEY}&page=${page}`
      );
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('TMDB Upcoming Error:', error);
      throw error;
    }
  },

  // Get trending movies
  async getTrending(timeWindow = 'week') {
    try {
      const response = await fetch(
        `${BASE_URL}/trending/movie/${timeWindow}?api_key=${API_KEY}`
      );
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('TMDB Trending Error:', error);
      throw error;
    }
  },

  // Get movie genres
  async getGenres() {
    try {
      const response = await fetch(
        `${BASE_URL}/genre/movie/list?api_key=${API_KEY}`
      );
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      return data.genres;
    } catch (error) {
      console.error('TMDB Genres Error:', error);
      throw error;
    }
  },

  // Helper function to build image URL
  getImageUrl(path, size = 'w500') {
    if (!path) return null;
    return `${IMAGE_BASE_URL}/${size}${path}`;
  },

  // Extract trailer from movie videos
  extractTrailer(videos) {
    if (!videos || !videos.results) return null;
    
    const trailer = videos.results.find(
      video => video.type === 'Trailer' && video.site === 'YouTube'
    );
    
    return trailer ? `https://www.youtube.com/embed/${trailer.key}` : null;
  },

  // Map TMDB movie to our form format
  mapMovieToForm(tmdbMovie) {
    const genres = tmdbMovie.genres?.map(g => g.name).slice(0, 2).join(', ') || '';
    const trailer = this.extractTrailer(tmdbMovie.videos);
    
    return {
      title: tmdbMovie.title || '',
      description: tmdbMovie.overview || '',
      genre: genres,
      year: tmdbMovie.release_date ? parseInt(tmdbMovie.release_date.split('-')[0]) : '',
      poster: this.getImageUrl(tmdbMovie.poster_path, 'w500') || '',
      trailer: trailer || '',
      rating: Math.min(Math.max(tmdbMovie.vote_average / 2, 0), 5).toFixed(1)
    };
  }
};

export default tmdbService;
